import React from 'react';
import InvoiceList from '../components/InvoiceList';

export default function Invoices() {
  return <InvoiceList />;
}
